import { csx, focusVisible, style } from '@vtex/admin-ui'

import * as searchItemStyles from '../ComboboxSearchItem/ComboboxSearchItem.styles'

const fakeOutline = style({
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -2,
    right: -2,
    bottom: -2,
    left: -2,
    boxShadow: '0 0 0 3px $gray30',
    borderRadius: 'inherit',
    pointerEvents: 'none',
    zIndex: -1,
  },
})

export const input = csx({
  flex: '1 1 auto',
  outline: 'none',
  '::placeholder': {
    text: '$body',
    color: '$secondary',
  },
  ':not(:placeholder-shown)': {
    width: 'calc(100% - 44px)',
  },
})

export const placeholder = style({
  color: '$gray50',
  pointerEvents: 'none',
  flex: '1 0 auto',
})

export const shortcut = style({
  borderRadius: '$base',
  padding: '0 0.375rem',
  backgroundColor: '$gray05',
})

export const form = style({
  marginLeft: '0.06rem',
  paddingLeft: '$space-3',
  height: '2.25rem',
  display: 'flex',
  alignItems: 'center',
  gap: '$space-2',
  border: '$form.neutral',
  borderRadius: '$base',
  bg: '$primary',
  color: '$primary',
  text: '$body',
  position: 'relative',
  width: '28.75rem',
  ':focus-within': {
    ...focusVisible('neutral'),
    ...fakeOutline,
    border: '$form.neutralFocus',
  },
  ':hover': {
    border: '$form.neutralHover',
  },
})

const disabledStyle = style({
  border: '$disabled',
  bg: '$disabled',
  color: '$disabled',
})

export const formDisabled = style({
  ...disabledStyle,
  input: { ...disabledStyle, border: 'none' },
})

export const searchingBy = style({
  ...searchItemStyles.searchingBy,
  padding: '0 0.375rem',
  height: '100%',
  maxHeight: '22px',
  lineHeight: '22px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const innerContainer = style({
  height: '100%',
})

export const icon = (disabled: boolean) =>
  style({
    color: disabled ? '$disabled' : '$secondary',
  })

export const clearButton = style({
  padding: '$space-0',
  paddingY: '$space-05',
  paddingX: '$space-1',
  height: 'fit-content',
})
